import {foundDuplicatedFavs} from './middleware1';
import {foundDuplicatedCart} from './middleware2';
export default [foundDuplicatedFavs, foundDuplicatedCart]